module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/svg/floatingtoolbar_link_font-ec81c3.svg";